import { useContext } from 'react'
import { ExportJobContext } from './ExportJob'

export const useExportJobContext = () => useContext(ExportJobContext)
